export enum ActivityStatus {
  PLANNED = 'PLANNED',

  OPEN = 'OPEN',

  ALERT = 'ALERT',

  CLOSED = 'CLOSED',
}
